export default __webpack_public_path__ + "static/media/120.55d58e33.png";